export default "/images/ec673001c51481691c5110dc350644a7.png";